import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { NotificationPage } from 'src/app/notification/notification.page';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {

  @Input() title: any =  '';
  @Input() desc: any =  '';
  @Input() breadcrumb: any =  '';
  @Input() buttonSearch: boolean =  false;
  viewType: any;

  manjang: boolean = false;

  
  constructor(
    public popoverController: PopoverController
  ) { }

  ngOnInit() {}

  
  search(){
    if(this.manjang == false){
      this.manjang = true;
    } else {
      this.manjang = false;
    }
    console.log(this.manjang)
  }

  async notif(ev: any) {
    const popover = await this.popoverController.create({
      component: NotificationPage,
      cssClass: 'notif-css',
      backdropDismiss: true,
      event: ev,
      translucent: true,
      showBackdrop: false
    });
    await popover.present();

    const { role } = await popover.onDidDismiss();
    console.log('onDidDismiss resolved with role', role);
  }

}
